<template>
    <ServiceLayout v-if="isLoginUser() && (!isBrandRoute && !isAuthRoute)"/>
    <BrandLayout v-else/>
    <ToastComponent/>
</template>

<script>
import store from "@/store";

// 전역 기반 CSS (모든 레이아웃 공통)
import('@/assets/css/main.css');
import('@/assets/css/base/color.css');
import('@/assets/css/base/typography.css');
import('@/assets/css/base/icon.css');

import BrandLayout from '@/layouts/BrandLayout.vue';
import ServiceLayout from '@/layouts/ServiceLayout.vue';
import ToastComponent from "@/components/common/ToastComponent.vue";

export default {
    name: 'App',
    components: {
        BrandLayout,
        ServiceLayout,
        ToastComponent
    },
    data() {
        return {
            isBrandRoute: false,
            isAuthRoute: false,
            isDefaultRoute: false
        };
    },
    watch: {
        $route(to) {
            this.checkRoute(to.path);
        }
    },
    mounted() {
        this.checkRoute(this.$route.path);
    },
    methods: {
        checkRoute(path) {
            this.isBrandRoute = path.startsWith('/brand')
            this.isAuthRoute = path.startsWith('/auth');
        },
        isLoginUser() {
            return store.getters['auth/isAuthenticated'];
        }
    }
};
</script>
